import dayjs from 'dayjs';
import utilsFormat from '@/utils/format';

const Filters = {
  install (Vue) {
    Vue.filter('dateTime', (value, format) => {
      if (dayjs(value)) {
        return dayjs(value)
          .format(format || 'DD MMMM YYYY HH:mm');
      }
      return value;
    });
    Vue.filter('priceFormat', (value) => {
      if (!value) {
        return '-';
      }
      return `${value} ₺`;
    });
    Vue.filter('formatPrice', (value, options) => {
      return utilsFormat.price(value, options);
    });
    Vue.filter('formatQuantity', (value) => {
      return utilsFormat.quantity(value);
    });
  },
};

export default Filters;
